var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte-ausgeklappt",
    transform: "translate(-394.000000, -708.000000)",
    className: "toggle",
    stroke: "#145685",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person-Copy",
    transform: "translate(112.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(239.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pen",
    transform: "translate(44.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6959641,0.434678635 L11.5653214,1.30403591 C12.1448929,1.88360742 12.1448929,2.82327852 11.5653214,3.40285003 L2.9681714,12 L0,12 L0,9.03182861 L8.59714996,0.434678635 C9.17672148,-0.144892878 10.1163926,-0.144892878 10.6959641,0.434678635 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4204285,1.61140012 L10.3885999,4.57957152 L7.4204285,1.61140012 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.9a20ecf8f5c3a94ad75f8fa6a4fd98de.svg";
export { ForwardRef as ReactComponent };